var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bindable } from 'aurelia-templating';
import { transient } from "aurelia-dependency-injection";
import { observable, PLATFORM } from 'aurelia-framework';
import { BindingSignaler } from "aurelia-templating-resources";
var ItemSlider = /** @class */ (function () {
    function ItemSlider(element, bindingSignaler) {
        var _this = this;
        this.element = element;
        this.bindingSignaler = bindingSignaler;
        this.values = [];
        this.label = "";
        this.toolTipProperty = "toolTipHtml";
        this.disabled = false;
        this.resizeEventHandler = function () {
            _this.bindingSignaler.signal('page-resized');
        };
        this.onKeyDown = function ($event) {
            if (!_this.sliderContainer || !_this.sliderContainer.contains($event.target) || _this.disabled) {
                return;
            }
            var maxIndex = _this.values.length - 1;
            var minIndex = 0;
            var currentIndex = _this.values.findIndex(function (x) { return x.id == _this.value; });
            if ($event.keyCode == '37') {
                if (currentIndex == minIndex) {
                    return;
                }
                _this.value = _this.values[currentIndex - 1].id;
            }
            else if ($event.keyCode == '39') {
                if (currentIndex == maxIndex) {
                    return;
                }
                _this.value = _this.values[currentIndex + 1].id;
            }
        };
        this.onMouseDown = function ($event) {
            if (!_this.sliderContainer || !_this.sliderContainer.contains($event.target) || _this.disabled) {
                return;
            }
            var pageX = $event.touches ? $event.touches[0].pageX : $event.pageX;
            document.addEventListener('mousemove', _this.onMouseMove, false);
            document.addEventListener('touchmove', _this.onMouseMove, false);
            document.addEventListener('mouseup', _this.onMouseUp, false);
            document.addEventListener('touchend', _this.onMouseUp, false);
            _this._offset = pageX - _this.sliderHandle.getBoundingClientRect().left;
        };
        this.onMouseMove = function ($event) {
            var pageX = $event.touches ? $event.touches[0].pageX : $event.pageX;
            var maxLeft = _this.sliderContainer.offsetWidth - _this.sliderHandle.offsetWidth;
            var left = (pageX - _this.sliderContainer.getBoundingClientRect().left - _this._offset);
            if (left <= 0) {
                left = 0;
            }
            else if (left > maxLeft) {
                left = maxLeft;
            }
            var max = _this.values.length;
            var min = 1;
            var current = Math.round((max - min) * (left / maxLeft) + min);
            _this.value = _this.values[current - 1].id;
        };
        this.onMouseUp = function ($event) {
            _this._offset = null;
            try {
                document.removeEventListener('mousemove', _this.onMouseMove, false);
                document.removeEventListener('mouseup', _this.onMouseUp, false);
                document.removeEventListener('touchmove', _this.onMouseMove, false);
                document.removeEventListener('touchend', _this.onMouseUp, false);
            }
            catch (ex) {
                console.log(ex);
            }
        };
        this.onSliderContainerClick = function ($event) {
            if (_this.disabled)
                return;
            var pageX = $event.touches ? $event.touches[0].pageX : $event.pageX;
            var maxLeft = _this.sliderContainer.offsetWidth - _this.sliderHandle.offsetWidth;
            var left = (pageX - _this.sliderContainer.getBoundingClientRect().left - (_this.sliderHandle.offsetWidth / 2));
            if (left <= 0) {
                left = 0;
            }
            else if (left > maxLeft) {
                left = maxLeft;
            }
            var max = _this.values.length;
            var min = 1;
            var current = Math.round((max - min) * (left / maxLeft) + min);
            _this.value = _this.values[current - 1].id;
        };
    }
    ItemSlider.prototype.attached = function () {
        var _this = this;
        if (this.sliderContainer && this.sliderHandle) {
            setTimeout(function () {
                _this.setValue();
            }, 500);
        }
        PLATFORM.global.addEventListener("resize", this.resizeEventHandler);
    };
    ItemSlider.prototype.detached = function () {
        PLATFORM.global.removeEventListener("resize", this.resizeEventHandler);
    };
    ItemSlider.prototype.select = function (id) {
        if (!this.disabled) {
            this.value = id;
        }
    };
    ItemSlider.prototype.sliderContainerChanged = function () {
        this.setValue();
    };
    ItemSlider.prototype.notSetLabelChanged = function () {
        if (this.values.filter(function (x) { return !x.id; }).length == 0) {
            if (this.notSetLabel) {
                this.values.unshift({ id: null, name: this.notSetLabel });
            }
        }
    };
    ItemSlider.prototype.valueChanged = function () {
        var _this = this;
        this.setValue();
        if (this.values.length > 0) {
            this.selectedValue = this.values.filter(function (x) { return x.id == _this.value; })[0];
        }
    };
    ItemSlider.prototype.sliderHandleChanged = function (newValue, oldValue) {
        if (newValue) {
            newValue.addEventListener('mousedown', this.onMouseDown, false);
            newValue.addEventListener('touchstart', this.onMouseDown, false);
            newValue.addEventListener('keydown', this.onKeyDown, false);
            this.setValue();
        }
        else if (oldValue) {
            oldValue.removeEventListener('mousedown', this.onMouseDown, false);
            oldValue.removeEventListener('touchstart', this.onMouseDown, false);
            oldValue.removeEventListener('keydown', this.onKeyDown, false);
        }
        this.setValue();
    };
    ItemSlider.prototype.setValue = function () {
        var _this = this;
        if (!this.sliderContainer || !this.sliderHandle) {
            return;
        }
        var max = this.values.length;
        var min = 1;
        var current = this.values.findIndex(function (x) { return x.id == _this.value; }) + 1;
        var percentage = (current - min) / (max - min);
        var left = this.sliderContainer.offsetWidth * percentage;
        if (left <= this.sliderContainer.offsetWidth && left >= 0) {
            this.sliderHandleLeft = left;
        }
        else if (left <= 0) {
            this.sliderHandleLeft = 0;
        }
        else if (left > this.sliderContainer.offsetWidth) {
            this.sliderHandleLeft = this.sliderContainer.offsetWidth;
        }
        var paramsEvent = { detail: { value: this.value }, bubbles: true };
        var changeValueEvent = new CustomEvent("value-changed", paramsEvent);
        this.element.dispatchEvent(changeValueEvent);
    };
    ItemSlider.prototype.onTooltipClick = function ($event) {
        $event.stopPropagation();
    };
    ItemSlider.prototype.getMargin = function (groupButtonValue) {
        if (groupButtonValue) {
            var width = groupButtonValue.offsetWidth;
            return Math.ceil(width / -2);
        }
        return 0;
    };
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], ItemSlider.prototype, "values", void 0);
    __decorate([
        observable(),
        __metadata("design:type", HTMLElement)
    ], ItemSlider.prototype, "sliderContainer", void 0);
    __decorate([
        observable(),
        __metadata("design:type", HTMLElement)
    ], ItemSlider.prototype, "sliderHandle", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ItemSlider.prototype, "label", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ItemSlider.prototype, "parameters", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ItemSlider.prototype, "toolTipProperty", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], ItemSlider.prototype, "value", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], ItemSlider.prototype, "tabindex", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ItemSlider.prototype, "disabled", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ItemSlider.prototype, "notSetLabel", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ItemSlider.prototype, "zIndex", void 0);
    ItemSlider = __decorate([
        transient(),
        __metadata("design:paramtypes", [Element, BindingSignaler])
    ], ItemSlider);
    return ItemSlider;
}());
export { ItemSlider };
